<template>
  <div>
    <!-- 使用 Vant 的 van-popup 组件 -->
    <van-popup
      v-model="visible"
      :closeable="closeable"
      :close-icon="closeIcon"
      :overlay="overlay"
      :close-on-click-overlay="false"
      :style="{ width: '100%', height: '100%' }"
      class="custom-popup"
    >
      <div class="tra-con" style="overflow: hidden" :key="timer">
        <div style="padding-bottom: 2%">
          <div
            class="d-flex t-c"
            style="
              justify-content: flex-end;
              margin-right: 20px;
              position: relative;
            "
          >
            <div @click="goJl" style="margin-right: 25px">
              <img
                src="../assets/img/lucky_jackpot/luttory_icon.png"
                width="45"
              />
              <p class="wihte-color">{{ $lang.common_txt51 }}</p>
            </div>
            <div @click="goRl">
              <img
                src="../assets/img/lucky_jackpot/luttory_icon2.png"
                width="45"
              />
              <p class="wihte-color">{{ $lang.common_txt52 }}</p>
            </div>
          </div>
          <div v-if="showJl" class="custom-top">
            <p class="triangle2"></p>
            <div class="custom-top--i">
              <div class="d-flex-s">
                <p>
                  {{ $lang.LuckyRoulette_txt }}
                  <span class="info-color">{{
                    $formatNumberWithCommas(bonusSum)
                  }}</span>
                </p>
                <van-button
                  class="popup-button"
                  :class="{
                    active: canReceiveLuckyRouletteBonus
                  }"
                  :disabled="!canReceiveLuckyRouletteBonus"
                  @click="getJl"
                >
                  {{ $lang.LuckyRoulette_txt2 }}
                </van-button>
              </div>
              <p class="f-t-12">
                {{ $lang.LuckyRoulette_txt3 }}
                <span class="error-color">{{ countdown }}</span>
              </p>
              <div class="d-flex m-t-10">
                <van-progress
                  :percentage="calculatedPercentage"
                  :pivot-text="`just ${$formatNumberWithCommas(remainingBonusToReward)} more to receive`"
                  stroke-width="20"
                  track-color="#202A39"
                />
                <p class="m-l-5 f-t-10 m-l-10">
                  {{ $lang.common_txt53 }}
                  {{ $formatNumberWithCommas(targetRewardLabel) }}
                  {{ $lang.common_txt54 }}
                </p>
              </div>
            </div>
          </div>
          <div v-if="showRl" class="custom-bottom">
            <p class="triangle3"></p>
            <div class="custom-bottom-i">
              <van-tabs
                background="transparent"
                @click="tabSelect"
                v-model="activeTab"
                title-inactive-color="#000000"
                title-active-color="#000000"
              >
                <van-tab
                  v-for="(item, index) in [$lang.Regras, 'meus registros']"
                  :key="index"
                >
                  <template #title>
                    <span
                      class="tab-text"
                      :class="{ 'active-color': index === activeTab }"
                      >{{ item }}</span
                    >
                  </template>
                  <div class="content-tab--c">
                    <div
                      v-if="activeTab === 0"
                      style="padding: 15px 10px; font-size: var(--vk-fs-xs)"
                      v-html="$lang.LuckyRoulette_txt11"
                    ></div>
                    <div v-if="activeTab === 1">
                      <div v-if="myRecordList.length > 0" class="m-t-15">
                        <div
                          class="record-bg"
                          v-for="(item, index) in myRecordList"
                          :key="index"
                        >
                          {{ formatRecordDate(item.drawDate) }}
                          Loteria,Ganhar
                          <span class="info-color"
                            >{{ getCurrency
                            }}{{ $formatNumberWithCommas(item.bonusSum) }}</span
                          >
                        </div>
                      </div>
                      <van-empty
                        v-else
                        :image="require('@/assets/img/common/img_no_data.png')"
                        :description="$lang.noempt"
                      />
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
            </div>
          </div>

          <div class="lettey-bg">
            <!-- <div class="content-jz"> -->
            <div class="container">
              <!-- 转盘容器 -->
              <div
                class="turntable"
                :style="{ transform: `rotate(${currentAngle}deg)` }"
              >
                <!-- 自行添加奖品分割线或使用背景图实现 -->
              </div>
              <!-- 操作按钮 -->
              <button
                class="pointer"
                :disabled="!canAttemptLuckyRoulette"
                @click="startRotation"
              >
                {{ $lang.LuckyRoulette_txt5 }}
                <span style="color: #ffcd28">{{ drawCount }}</span>
                {{ $lang.LuckyRoulette_txt6 }}
              </button>
              <div v-if="isShareBtn" class="triangle"></div>
              <div v-if="isShareBtn" class="btn-share" style="color: #ffffff">
                {{ $lang.LuckyRoulette_txt7 }}
                <p
                  class="btn-share--b"
                  style="color: var(--vk-bg)"
                  @click="shareContent"
                >
                  <img
                    src="../assets/img/lucky_jackpot/img_share.png"
                    width="15px"
                    class="m-r-10"
                  />{{ $lang.LuckyRoulette_txt8 }}
                </p>
                <p>
                  {{ $lang.LuckyRoulette_txt9 }}
                  <span class="info-color"></span>
                  {{ $lang.LuckyRoulette_txt10 }}
                </p>
                <span
                  class="vk-touch-44"
                  role="button"
                  aria-label="refresh"
                  @click="toggleRotation"
                >
                  <img
                    src="../assets/img/common/home_top_refresh.png"
                    style="
                      background: var(--vk-brand);
                      border-radius: 50%;
                      width: 17px;
                      padding: 2px;
                    "
                  />
                </span>
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="t-c">
          <img
            @click="visible = false"
            src="../assets/img/lucky_jackpot/img_cancel.png"
            width="35"
          />
        </div>
      </div>
      <van-overlay :show="showJl" @click="goJl" class="custom-overlay">
      </van-overlay>
      <van-overlay :show="showRl" @click="goRl" class="custom-overlay">
      </van-overlay>
    </van-popup>

    <van-dialog
      v-model="showDialog"
      title=" "
      style="width: 100%; background: transparent; border-radius: 0px"
      :showConfirmButton="false"
    >
      <div class="tc-bg">
        <img
          src="../assets/img/lucky_jackpot/img_cancel.png"
          width="35"
          style="position: absolute; right: 30px; top: 65px"
          @click="showDialog = false"
        />
        <p class="tc-bg--sum">
          {{ getCurrency }} {{ $formatNumberWithCommas(getBonusSum) }}
        </p>
        <div class="tc-bg--i" style="color: #ffffff">
          {{ $lang.LuckyRoulette_txt12 }}
          <span class="info-color"
            >{{ getCurrency }} {{ $formatNumberWithCommas(getBonusSum) }}</span
          >{{ $lang.LuckyRoulette_txt13 }}
          <span class="info-color"
            >{{ getCurrency }}
            {{ $formatNumberWithCommas(remainingBonusAfterSpin) }}</span
          >
          <template v-if="minInviteCountToReward > 0">
            {{ $lang.LuckyRoulette_txt14
            }}<span class="info-color">{{ minInviteCountToReward }}</span>
          </template>
          <template v-if="minBetAmountToReward > 0">
            {{ $lang.LuckyRoulette_txt15 }}
            <span class="info-color"
              >{{ getCurrency }}
              {{ $formatNumberWithCommas(minBetAmountToReward) }}</span
            >.
          </template>
        </div>
      </div>

      <p class="ok-btn" @click="shareContent">
        <img
          src="../assets/img/lucky_jackpot/img_share.png"
          width="20px"
          class="m-r-10"
        />
        {{ $lang.Compartilhar }}
      </p>
    </van-dialog>
    <login v-model="showLogin" overlay></login>
  </div>
</template>

<script>
import {
  GetLuckyRoulette,
  LuckyRoulette,
  GetLuckyRouletteRecord,
  ReceiveLuckyRouletteBonus
} from '@/api/common'
import {
  failMessage as rewardFailMessage,
  hasRewardIssueProof,
  isRewardClaimSuccessWithProof,
  isNeedLogin,
  isOkResponse,
  isRouletteSuccess as rewardRouletteSuccess,
  responseContent
} from '@/views/details/activity/rewardApi'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { safeInviteUrl } from '@/components/share/shareSafety'

const SHARE_FAILED_MESSAGE = 'Share failed'
const SHARE_UNSUPPORTED_MESSAGE = 'Share is not available in this browser'
const SHARE_CANCELLED_NAMES = ['aborterror', 'notallowederror']
const GENERIC_SHARE_FAILURE_RE = /^(request failed|network error|sharing failed|share failed|\[object object\])$/i

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) {
    return null
  }
  return null
}

function getLocationOrigin() {
  try {
    return typeof window !== 'undefined' && window && window.location ? (window.location.origin || '') : ''
  } catch (e) {
    return ''
  }
}

function safeString(value) {
  return String(value == null ? '' : value).trim()
}

function shareFailureMessage(error, fallback = SHARE_FAILED_MESSAGE) {
  const errorName = safeString(error && error.name).toLowerCase()
  if (SHARE_CANCELLED_NAMES.includes(errorName)) {
    return ''
  }
  const message = safeString(error && error.message)
  return message && !GENERIC_SHARE_FAILURE_RE.test(message) ? message : fallback
}

function buildShareUrl(storage) {
  try {
    return safeInviteUrl(
      getLocationOrigin(),
      safeGetStorageItem(storage, 'country'),
      safeGetStorageItem(storage, 'shareCode')
    ) || ''
  } catch (e) {
    return ''
  }
}

function getNavigator() {
  try {
    return typeof navigator === 'undefined' ? null : navigator
  } catch (e) {
    return null
  }
}

function getNativeShare() {
  const nav = getNavigator()
  try {
    return nav && typeof nav.share === 'function' ? { nav, share: nav.share } : null
  } catch (e) {
    return null
  }
}

function canUseNativeShare() {
  try {
    const nav = getNavigator()
    return Boolean(nav && typeof nav.share === 'function')
  } catch (e) {
    return false
  }
}

function safeToast(vm, payload) {
  if (vm && typeof vm.$toast === 'function') vm.$toast(payload)
}

function callNativeShare(nativeShare, payload) {
  try {
    if (!nativeShare || typeof nativeShare.share !== 'function') {
      return Promise.reject(new Error(SHARE_UNSUPPORTED_MESSAGE))
    }
    if (payload && payload.url) {
      return nativeShare.share
        .call(nativeShare.nav, {
          title: payload.title,
          text: payload.text,
          url: payload.url
        })
    }
    return nativeShare.share.call(nativeShare.nav, payload)
  } catch (e) {
    return Promise.reject(e)
  }
}

const DEFAULT_JACKPOT_TARGETS = {
  BRL: 100,
  DEFAULT: 15000
}

export default {
  name: 'LuckyRoulette',
  props: {
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    closeable: {
      type: Boolean,
      default: false
    },
    // 关闭按钮的图标
    closeIcon: {
      type: String,
      default: 'cross'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showJl: false,
      showRl: false,
      isShareBtn: false,
      getBonusSum: 0,
      showLogin: false,
      showDialog: false,
      countdown: '00:00:00', // 初始化倒计时显示
      timer2: null, // 定时器
      timer: 0,
      myRecordList: [],
      activeTab: 0,
      bonusSum: 0,
      drawCount: 0,
      targetAmount: 0,
      targetReward: 0,
      minInviteCountToReward: 0,
      minBetAmountToReward: 0,
      receiveStatus: 0,
      claimable: false,
      canReceive: false,
      writeActionsEnabled: false,
      componentDestroyed: false,
      visible: this.value, // 内部状态
      currentAngle: 0, // 当前旋转角度
      isSpinning: false, // 是否正在旋转
      prizeCount: 6 // 奖品总数（根据实际修改）
    }
  },
  computed: {
    jackpotThreshold() {
      const configured = this.safeNumber(this.targetAmount)
      if (configured > 0) return configured
      return DEFAULT_JACKPOT_TARGETS[this.getCurrency] || DEFAULT_JACKPOT_TARGETS.DEFAULT
    },
    targetRewardLabel() {
      const reward = this.safeNumber(this.targetReward, this.jackpotThreshold)
      return reward > 0 ? reward : this.jackpotThreshold
    },
    remainingBonusToReward() {
      const remaining = this.jackpotThreshold - this.safeNumber(this.bonusSum)
      return Math.max(0, remaining)
    },
    remainingBonusAfterSpin() {
      const remaining = this.jackpotThreshold - this.safeNumber(this.getBonusSum)
      return Math.max(0, remaining)
    },
    calculatedPercentage() {
      const threshold = this.jackpotThreshold
      const bonus = Number(this.bonusSum) || 0
      if (bonus <= 0) {
        return 0
      } else if (bonus >= threshold) {
        return 100
      }
      return Math.round((bonus / threshold) * 100)
    },
    canReceiveLuckyRouletteBonus() {
      return this.writeActionsEnabled && (
        this.receiveStatus === 1 ||
        this.claimable ||
        this.canReceive
      )
    },
    canAttemptLuckyRoulette() {
      return this.writeActionsEnabled && !this.isSpinning
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
      if (newVal && this.token) this.GetLuckyRoulette()
    }
  },
  mounted() {
    this.componentDestroyed = false
    if (this.token && this.visible) {
      this.GetLuckyRoulette()
    }
    this.startCountdown()
  },
  beforeDestroy() {
    this.componentDestroyed = true
    // 组件销毁时清除定时器
    if (this.timer2) {
      clearInterval(this.timer2)
    }
  },
  methods: {
    isComponentAlive() {
      return !this.componentDestroyed && !this._isDestroyed && !this._isBeingDestroyed
    },
    requireLogin() {
      if (!this.isComponentAlive()) return
      this.isSpinning = false
      this.showLogin = true
      this.$emit('login-key')
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    apiFailMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.')
    },
    firstValue(...values) {
      return values.find(value => value !== undefined && value !== null && value !== '')
    },
    safeNumber(value, fallback = 0) {
      const n = Number(value)
      return Number.isFinite(n) ? n : fallback
    },
    boolValue(value, fallback = false) {
      if (value === undefined || value === null || value === '') return fallback
      if (value === true || value === 1) return true
      if (value === false || value === 0) return false
      const normalized = String(value).trim().toLowerCase()
      if (['1', 'true', 'yes', 'y', 'on'].includes(normalized)) return true
      if (['0', 'false', 'no', 'n', 'off'].includes(normalized)) return false
      return fallback
    },
    resetRouletteState() {
      this.bonusSum = 0
      this.drawCount = 0
      this.receiveStatus = 0
      this.claimable = false
      this.canReceive = false
      this.writeActionsEnabled = false
    },
    isRewardReadUnavailable(res) {
      const root = res && res.response && res.response.data ? res.response.data : res
      const stack = [root, responseContent(root)]
      const seen = new Set()
      while (stack.length) {
        const source = stack.shift()
        if (!source || typeof source !== 'object' || seen.has(source)) continue
        seen.add(source)
        if ([
          source.dataUnavailable,
          source.data_unavailable,
          source.readFailure,
          source.read_failure,
          source.readUnavailable,
          source.read_unavailable,
          source.readOnlyReward,
          source.read_only_reward
        ].some(value => this.boolValue(value))) return true
        const marker = this.markerToken([
          source.fallbackSource,
          source.fallback_source,
          source.source,
          source.reason,
          source.blockedReason,
          source.blocked_reason
        ].filter(Boolean).join(' '))
        if (marker.includes('read-unavailable') ||
          marker.includes('readunavailable') ||
          marker.includes('missingtable') ||
          marker.includes('missing_table') ||
          marker.includes('missing table') ||
          marker.includes('missingcolumn') ||
          marker.includes('missing_column') ||
          marker.includes('missing column')) return true
        ;['content', 'data', 'body', 'detail', 'diagnostics', 'diagnostic', 'payload', 'extra'].forEach(key => {
          const value = source[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    markerToken(value) {
      return String(value || '').trim().toLowerCase()
    },
    hasBlockedReturnMarker(payload, seen = new Set()) {
      if (!payload || typeof payload !== 'object' || seen.has(payload)) return false
      seen.add(payload)
      return Object.entries(payload).some(([key, value]) => {
        const normalizedKey = String(key || '').trim().toLowerCase()
        if (['rewardproof', 'writeproof'].includes(normalizedKey) &&
          (value === false || value === 0 || ['0', 'false', 'no', 'off'].includes(this.markerToken(value)))) return true
        if (['readonly', 'read_only', 'readonlymode', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalerror', 'technical_error', 'technicalexception', 'technical_exception', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'missingtable', 'missing_table', 'missingcolumn', 'missing_column', 'mock', 'mockmode', 'mock_mode', 'mock_fallback', 'mockfallback', 'stub', 'fallback', 'fallback_used', 'not_connected', 'notconnected', 'not_implemented', 'notimplemented', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'writeblocked', 'write_blocked', 'failclosed', 'fail_closed', 'falseproof', 'false_proof', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'unconfirmedsuccess', 'unconfirmed_success', 'unimplemented'].includes(normalizedKey) &&
          (value === true || value === 1 || ['1', 'true', 'yes', 'on', 'mock', 'mockmode', 'mock_mode', 'stub', 'fallback', 'fallback_used', 'read_only', 'readonly', 'read_only_mode', 'readonlymode', 'read_only_reward', 'readonlyreward', 'read_unavailable', 'readunavailable', 'route_unavailable', 'routeunavailable', 'technical_error', 'technicalerror', 'technical_exception', 'technicalexception', 'technical_marker', 'technicalmarker', 'backend_failure', 'backendfailure', 'missingtable', 'missing_table', 'missing table', 'missingcolumn', 'missing_column', 'missing column', 'not_connected', 'notconnected', 'not_implemented', 'notimplemented', 'unimplemented', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'writeblocked', 'write_blocked', 'failclosed', 'fail_closed', 'fail closed', 'falseproof', 'false_proof', 'false proof', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'payment status unconfirmed', 'unconfirmed', 'unconfirmedsuccess', 'unconfirmed_success'].includes(this.markerToken(value)))) {
          return true
        }
        if (['message', 'msg', 'reason'].includes(normalizedKey)) {
          const text = this.markerToken(value)
          if (text.includes('未接入') || text.includes('mock') || text.includes('stub') || text.includes('fallback') || text.includes('只读') || text.includes('阻止假成功') || text.includes('阻止假抽奖') || text.includes('writeblocked') || text.includes('write blocked') || text.includes('write_blocked') || text.includes('backendblocked') || text.includes('backend blocked') || text.includes('backend_blocked') || text.includes('backendfailure') || text.includes('backend failure') || text.includes('backend_failure') || text.includes('missingtable') || text.includes('missing table') || text.includes('missing_table') || text.includes('missingcolumn') || text.includes('missing column') || text.includes('missing_column') || text.includes('rewardbackendblocked') || text.includes('reward backend blocked') || text.includes('reward_backend_blocked') || text.includes('failclosed') || text.includes('fail closed') || text.includes('fail_closed') || text.includes('falseproof') || text.includes('false proof') || text.includes('false_proof') || text.includes('paymentstatusunconfirmed') || text.includes('payment status unconfirmed') || text.includes('payment_status_unconfirmed') || text.includes('unconfirmed') || text.includes('not_connected') || text.includes('not connected') || text.includes('not_implemented') || text.includes('not implemented') || text.includes('routeunavailable') || text.includes('route unavailable') || text.includes('route_unavailable') || text.includes('readunavailable') || text.includes('read unavailable') || text.includes('read_unavailable') || text.includes('technicalerror') || text.includes('technical error') || text.includes('technical_error') || text.includes('technicalmarker') || text.includes('technical marker') || text.includes('technical_marker') || text.includes('technicalexception') || text.includes('technical exception') || text.includes('technical_exception') || text.includes('技术错误') || text.includes('技术异常') || text.includes('unimplemented')) return true
        }
        return value && typeof value === 'object' && this.hasBlockedReturnMarker(value, seen)
      })
    },
    isReceiveSuccess(res) {
      const rewardClaimSuccess = isRewardClaimSuccessWithProof
      return rewardClaimSuccess(res) && !this.hasBlockedReturnMarker(res)
    },
    goJl() {
      this.showJl = !this.showJl
      // if (this.showJl) {
      //   this.showRl = false
      // }
    },
    goRl() {
      this.showRl = !this.showRl
      // if (this.showRl) {
      //   this.showJl = false
      // }
    },
    toggleRotation() {
      this.GetLuckyRoulette()
    },
    normalizeRecordList(content) {
      const list = content && (
        content.myRecordList ||
        content.recordList ||
        content.list ||
        content.records
      )
      return Array.isArray(list)
        ? list.map(item => ({
          drawDate: item.drawDate || item.createTime || item.createdAt || item.date || '',
          bonusSum: this.safeNumber(this.firstValue(item.bonusSum, item.amount, item.rewardAmount, item.bonus))
        }))
        : []
    },
    formatRecordDate(date) {
      if (!date) return '--'
      const text = this.$dayjs(date).format('YYYY-MM-DD')
      if (!text || text === 'Invalid Date') return '--'
      return `${text.slice(8, 10)}/${text.slice(5, 7)}/${text.slice(0, 4)}`
    },
    isRouletteSuccess(res) {
      return rewardRouletteSuccess(res) && hasRewardIssueProof(res) && !this.hasBlockedReturnMarker(res)
    },
    resolvePrizeIndex(content) {
      const rawIndex = content && this.firstValue(
        content.prizeIndex,
        content.targetIndex,
        content.awardIndex,
        content.index,
        content.prizeNo,
        content.position
      )
      const index = Number(rawIndex)
      if (Number.isFinite(index) && index >= 0) {
        return Math.floor(index) % this.prizeCount
      }
      return 0
    },
    shareContent() {
      const storage = getLocalStorage()
      const shareUrl = buildShareUrl(storage)
      if (!shareUrl) {
        safeToast(this, {
          message: this.$lang.share_failed || SHARE_FAILED_MESSAGE,
          icon: 'cross'
        })
        return
      }
      if (canUseNativeShare()) {
        const nativeShare = getNativeShare()
        if (!nativeShare) {
          safeToast(this, {
            message: this.$lang.share_not_available || SHARE_UNSUPPORTED_MESSAGE,
            icon: 'cross'
          })
          return
        }
        const shareResult = callNativeShare(nativeShare, {
          title: 'VUKAVI',
          text: 'VUKAVI',
          url: shareUrl
        })
        if (shareResult && typeof shareResult.catch === 'function') {
          shareResult.catch((error) => {
            const message = shareFailureMessage(error, this.$lang.share_failed || SHARE_FAILED_MESSAGE)
            if (message) {
              safeToast(this, {
                message,
                icon: 'cross'
              })
            }
          })
        }
      } else {
        safeToast(this, {
          message: this.$lang.share_not_available || SHARE_UNSUPPORTED_MESSAGE,
          icon: 'cross'
        })
      }
    },
    async getJl() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      try {
        const data = await ReceiveLuckyRouletteBonus({})
        if (isNeedLogin(data)) {
          this.requireLogin()
          return
        }
        if (this.isReceiveSuccess(data)) {
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          this.GetLuckyRoulette()
        } else {
          this.$toast({
            message: this.apiFailMessage(data, this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.'),
            icon: 'cross'
          })
        }
      } catch (error) {
        const networkFallback = this.$lang.network_error || 'Network error'
        this.$toast({
          message: this.apiFailMessage(error, networkFallback),
          icon: 'cross'
        })
      }
    },
    startCountdown() {
      // 获取后一天早上7点的时间戳
      const targetDate = new Date()
      targetDate.setDate(targetDate.getDate() + 1) // 后一天
      targetDate.setHours(7, 0, 0, 0) // 设置为早上7点

      // 每秒更新一次倒计时
      this.timer2 = setInterval(() => {
        const now = new Date()
        const timeLeft = targetDate - now // 剩余时间（毫秒）

        if (timeLeft > 0) {
          // 计算时分秒
          const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24)
          const minutes = Math.floor((timeLeft / (1000 * 60)) % 60)
          const seconds = Math.floor((timeLeft / 1000) % 60)

          // 格式化为两位数
          this.countdown = `${String(hours).padStart(2, '0')}:${String(
            minutes
          ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        } else {
          // 如果时间已过，停止倒计时
          clearInterval(this.timer2)
          this.countdown = '00:00:00'
        }
      }, 1000) // 每秒更新一次
    },
    tabSelect(i) {
      if (i === 1) {
        if (this.token) {
          this.GetLuckyRouletteRecord()
        }
        //  else {
        //   this.$router.push({ path: '/home', query: { isValue: 'isLogin' } })
        // }
      }
    },
    async GetLuckyRouletteRecord() {
      try {
        const data = await GetLuckyRouletteRecord({})
        if (!this.isComponentAlive()) return
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isRewardReadUnavailable(data)) {
          this.myRecordList = []
        } else if (isOkResponse(data) && !this.hasBlockedReturnMarker(data)) {
          this.myRecordList = this.normalizeRecordList(responseContent(data))
        } else {
          this.myRecordList = []
          if (this.isRewardReadUnavailable(data)) return
          this.$toast({
            message: this.apiFailMessage(data),
            icon: 'cross'
          })
        }
      } catch (error) {
        if (!this.isComponentAlive()) return
        this.myRecordList = []
        if (this.isRewardReadUnavailable(error)) return
        this.$toast({
          message: this.apiFailMessage(error, this.$lang.request_failed || 'Request failed. Please try again later.'),
          icon: 'cross'
        })
      }
    },
    async GetLuckyRoulette() {
      try {
        const data = await GetLuckyRoulette({})
        if (!this.isComponentAlive()) return
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isRewardReadUnavailable(data)) {
          this.resetRouletteState()
        } else if (isOkResponse(data) && !this.hasBlockedReturnMarker(data)) {
          const content = responseContent(data)
          const rules = content.rules || {}
          const targetAmount = this.safeNumber(
            this.firstValue(content.targetAmount, content.targetReward, rules.bonusAmount, rules.targetAmount),
            this.jackpotThreshold
          )
          this.bonusSum = this.safeNumber(content.bonusSum)
          this.drawCount = this.safeNumber(content.drawCount)
          this.targetAmount = targetAmount
          this.targetReward = this.safeNumber(this.firstValue(content.targetReward, content.targetAmount), targetAmount)
          this.minInviteCountToReward = this.safeNumber(this.firstValue(content.minInviteCountToReward, rules.minInviteCountToReward))
          this.minBetAmountToReward = this.safeNumber(this.firstValue(content.minBetAmountToReward, rules.minBetAmountToReward))
          this.receiveStatus = this.safeNumber(content.receiveStatus)
          this.claimable = this.boolValue(content.claimable)
          this.canReceive = this.boolValue(content.canReceive)
          this.writeActionsEnabled = this.boolValue(this.firstValue(content.writeActionsEnabled, content.rewardWritable), true)
        } else {
          this.resetRouletteState()
          if (this.isRewardReadUnavailable(data)) return
          this.$toast({
            message: this.apiFailMessage(data),
            icon: 'cross'
          })
        }
      } catch (error) {
        if (!this.isComponentAlive()) return
        this.resetRouletteState()
        if (this.isRewardReadUnavailable(error)) return
        this.$toast({
          message: this.apiFailMessage(error, this.$lang.request_failed || 'Request failed. Please try again later.'),
          icon: 'cross'
        })
      }
    },
    async spinRoulette() {
      const data = await LuckyRoulette({})
      if (isNeedLogin(data)) {
        this.requireLogin()
        return null
      }
      if (this.isRouletteSuccess(data)) {
        const content = responseContent(data)
        this.getBonusSum = this.safeNumber(content.bonusSum)
        this.drawCount = this.safeNumber(content.drawCount, Math.max(this.drawCount - 1, 0))
        return this.resolvePrizeIndex(content)
      }
      this.$toast({
        message: this.apiFailMessage(data, this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.'),
        icon: 'cross'
      })
      return null
    },

    // 开始旋转
    async startRotation() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (!this.writeActionsEnabled) {
        this.$toast({
          message: this.apiFailMessage({ content: { readOnly: true, writeBlocked: true } }, this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.'),
          icon: 'cross'
        })
        return
      }
      if (this.drawCount <= 0) {
        this.isShareBtn = true
        this.$toast({
          message: this.$lang.LuckyRoulette_txt7 || 'Invite friends to get more spins',
          icon: 'cross'
        })
      } else {
        this.isShareBtn = false
      }

      if (this.isSpinning) return
      this.isSpinning = true

      try {
        const res = await this.spinRoulette()
        if (res == null) {
          this.isSpinning = false
          return
        }
        this.rotateTurntable(res)
      } catch (error) {
        this.$toast({
          message: this.apiFailMessage(error, this.$lang.request_failed || 'Request failed. Please try again later.'),
          icon: 'cross'
        })
        this.isSpinning = false
      }
    },

    // 执行转盘旋转
    rotateTurntable(targetIndex) {
      // 计算每个奖品区块角度
      const sectorAngle = 360 / this.prizeCount

      // 目标角度 = 完整圈数 + 目标位置角度 - 校正偏差
      const fullCircles = 3 * 360 // 至少旋转3圈
      const targetAngle = fullCircles + targetIndex * sectorAngle

      // 计算最终角度（注意要基于当前角度继续旋转）
      this.currentAngle += fullCircles - (this.currentAngle % 360) + targetAngle
      // 动画结束后恢复状态
      setTimeout(() => {
        this.isSpinning = false
        this.showDialog = true
        this.timer++
        this.showDialog = true
        this.GetLuckyRoulette()
        this.GetLuckyRouletteRecord()
        // 这里可以添加中奖提示
        // this.$toast({
        //   message: `恭喜获得奖品 ${targetIndex + 1}`,
        //   icon: 'success'
        // })
      }, 4500) // 需要与CSS动画时间匹配
    }
  }
}
</script>

<style lang="less" scoped>
/* 可以在这里添加自定义样式 */
.custom-popup {
  padding-top: 3vh;
  background-color: transparent; /* 设置背景色 */
  ::v-deep .van-tab--active ::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0px;
    margin: 0 auto;
    width: 35px;
    height: 3px; /* 设置渐变阴影的高度 */
    background: linear-gradient(to right, #ffd117, #f7ba17, #ffd117);
  }
  ::v-deep .van-tabs__line {
    display: none;
  }
}

.content-jz {
  width: 300px;
  height: 320px;
  background: url('../assets/img/lucky_jackpot/zhuanpankuang2.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 28px;
  margin: 0 auto;
}
.container {
  position: relative;
  width: 266px;
  height: 265px;
  // width: 70vw;
  // height: 32vh;
  margin: 0 auto;
}
.turntable {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: url('../assets/img/lucky_jackpot/zhuanpan2.png') no-repeat
    center/cover;
  transition: transform 4.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.pointer {
  position: absolute;
  top: 29%;
  left: 34%;
  width: 95px;
  height: 105px;
  background: url('../assets/img/lucky_jackpot/anniu2.png') no-repeat;
  background-size: 100% 100%;
  z-index: 1;
  border: none;
  color: white;
  padding: 12px 10px 0 10px;
}
.btn-share {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 13px;
  padding: 10px;
  font-size: var(--vk-fs-xs);
  top: 150px;
  line-height: 15px;
  z-index: 9;
}
.vk-touch-44 {
  /* a11y:44×44 触控热区(WCAG 2.5.5),负 margin 抵消占位,视觉不变 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: -12px;
  cursor: pointer;
}
.custom-top {
  z-index: 99999;
  position: absolute;
  // border: 1px solid #f0d767;
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 90%;
}
.custom-top--i {
  // background: #beeeff;
  background: #ffffff;
  border-radius: 13px;
  padding: 10px 15px;
  // color: #ffffff;
}
.active {
  // box-shadow: 0 2px 1px #7f7f7f !important; /* 阴影效果 */
  background: linear-gradient(to right, #adadad, #a4a4a4) !important;
}
.popup-button {
  opacity: 1;
  background: linear-gradient(to right, #d62345, #d62345);
  // box-shadow: 0 2px 1px #580f1d; /* 阴影效果 */
  border: none;
  border-radius: 8px; /* 圆角 */
  font-weight: bold;
  width: 60px;
  height: 25px !important;
  color: #ffffff;
  font-size: var(--vk-fs-xs);
}
::v-deep .van-progress__pivot {
  background-color: transparent !important;
  color: #ffffff;
  left: 0 !important;
  width: 198px;
}
::v-deep .van-progress {
  border-radius: 10px;
  // background: #21372d;
  border: 3px solid #2a3546;
  width: 195px;
  // border: 1px solid #476057;
}
::v-deep .van-progress__portion {
  background: @brand;
  width: 175px !important;
}
.custom-bottom {
  z-index: 99999;
  // border: 1px solid #f0d767;

  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 90%;
  ::v-deep .van-tabs__wrap {
    border-radius: 12px;
    position: sticky;
    // background: #beeeff;
    background: #ffffff;

    top: 0;
  }
  /* 隐藏滚动条样式 */
  &::-webkit-scrollbar {
    display: none;
  }
}
.custom-bottom-i {
  // background: #beeeff;
  background: #ffffff;
  border-radius: 13px;
  padding-bottom: 20px;
  max-height: 50vh;
  overflow-y: scroll;
  min-height: 50vh;
}

::v-deep .van-tabs__nav {
  width: 220px;
}

.record-bg {
  border-radius: 5px;
  border: 1px solid #ababab;
  padding: 5px;
  // color: #ffffff;
  font-size: var(--vk-fs-xs);
  width: 95%;
  margin: 0 auto 10px;
}
::v-deep .van-popup__close-icon {
  color: #ffffff;
  border: 3px solid #ffffff;
  border-radius: 50%;
  padding: 3px;
}
::v-deep .van-popup__close-icon--top-right {
  right: 3px;
}
.tc-bg {
  width: 100%;
  height: 400px;
  background: url('../assets/img/lucky_jackpot/tc.png') no-repeat;
  background-size: 100% 100%;
  text-align: center;
  position: relative;
}
.tc-bg--sum {
  position: absolute;
  font-size: 32px;
  left: 0;
  right: 0;
  bottom: 103px;
  margin: 0 auto;
  color: @info-color;
}
.tc-bg--i {
  position: absolute;
  width: 80%;
  border: 1px solid #f0d767;
  background: linear-gradient(to right, #1f3151, #1e2532);
  border-radius: 13px;
  font-size: var(--vk-fs-xs);
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 5px;
  text-align: left;
  line-height: 15px;
  padding: 10px;
}
.ok-btn {
  width: 45%;
  background: @brand;
  border-radius: 30px;
  padding: 12px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px auto 0;
  color: var(--vk-bg);
}
.btn-share--b {
  background: @brand;
  border-radius: 8px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
}
.triangle {
  top: 137px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 9;
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid rgba(0, 0, 0, 0.5); /* 透明黑色 */
}
// .tra-con {
//   transform: scale(0.8);
// }
.lettey-bg {
  background: url(../assets/img/lucky_jackpot/zhuanpankuang2.png) no-repeat;
  background-size: 100% 100%;
  height: 525px;
  padding-top: 172px;
  // height: 62vh;
  // padding-top: 20vh;
  // max-width: var(--vk-pc-col);
  margin: 0 auto;
}
.triangle2 {
  width: 0;
  height: 0;
  border-left: 10px solid transparent; /* 左边框透明 */
  border-right: 10px solid transparent; /* 右边框透明 */
  // border-bottom: 19px solid #beeeff; /* 底边框颜色 */
  border-bottom: 19px solid #ffffff; /* 底边框颜色 */
  margin-left: 73%;
}
.triangle3 {
  width: 0;
  height: 0;
  border-left: 10px solid transparent; /* 左边框透明 */
  border-right: 10px solid transparent; /* 右边框透明 */
  // border-bottom: 19px solid #beeeff; /* 底边框颜色 */
  border-bottom: 19px solid #ffffff; /* 底边框颜色 */

  margin-left: 90%;
}
.custom-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
/* PC 端样式 */
@media (min-width: 769px) {
  .lettey-bg {
    height: 575px;
    padding-top: 187px;
  }
  .container {
    height: 291px;
    width: 292px;
  }
}
</style>
